import { UserJobTitleEnum } from "@gap/backend/app-services/user/models/UserJobTitleDto";
import { CacheHandler } from "reusable/utils/cache";

export const trialCache = {
   completedWelcome: new CacheHandler<boolean>({ key: 'trial:completed-welcome', cacheLocation: 'localStorage' }),
   verificationData: new CacheHandler<VerificationData>({ key: 'trial:verification', cacheLocation: 'localStorage' }),
}

export interface VerificationData {
   lastName: string
   firstName: string
   jobTitle: UserJobTitleEnum
   email: string
   verified: boolean
   userId: string
}
